export default __webpack_public_path__ + "static/img/profile-banner.eb83123.jpg";